import { computed, ref } from "vue";
import { useRoute } from "#app";
export const useMode = () => {
  const route = useRoute();
  let route_name = computed(() => route.name);
  const current_name_page = ref("global");
  const current_lang_page = ref("vi-VN");
  if (route_name.value?.includes("___")) {
    current_name_page.value = route_name.value?.split("___")?.[0] || "global";
    current_lang_page.value = route_name.value?.split("___")?.pop() || "vi-VN";
  } else {
    current_name_page.value = route_name.value || "global";
    current_lang_page.value = "vi-VN";
  }
  return {
    current_name_page,
    current_lang_page
  };
};
